import axiosClient from "@/axios";
import { AxiosPromise } from "axios";
import {
  TrackingMappingCarriersResponse,
  TrackingMappingTable,
} from "@/models/TrackingMapping";

// Internal-only reference data: the endpoint answers 403 for a customer, which
// is what keeps the page closed rather than any client-side role check.
const trackingMappingsService = {
  carriers(): AxiosPromise<TrackingMappingCarriersResponse> {
    return axiosClient.get("/tracking-mappings");
  },
  table(supplierId: number): AxiosPromise<TrackingMappingTable> {
    return axiosClient.get(`/tracking-mappings/${supplierId}`);
  },
};

export default trackingMappingsService;
